export const APPOINTMENT_PROGRESS_BAR = [
    {
        label: "Car Details",
        visited: false,
        active: false,
        children: {
            brand: false,
            model: false
        }
    },
    {
        label: "Branch",
        visited: false,
        active: false,
        children: {
            date: false
        }
    },
    {
        label: "Appointment",
        visited: false,
        active: false,
        children: null
    }
];

export const DEFAULT_PROGRESS_BAR = [
    {
        label: "Car Details",
        visited: false,
        active: false,
        children: {
            brand: false,
            model: false,
            year: false,
            variant: false,
            registrationState: false,
            kilometersDriven: false
        }
    },
    {
        label: "Appointment",
        visited: false,
        active: false,
        children: {
            notUsedKey: false
        }
    },
    {
        label: "Sell Car",
        visited: false,
        active: false,
        children: null
    }
];

export const MARKETING_PROGRESS_BAR = [
    {
        label: "Car Details",
        visited: false,
        active: false,
        children: {
            brand: false,
            model: false
        }
    },
    {
        label: "Appointment",
        visited: false,
        active: false,
        children: {
            branch: false
        }
    },
    {
        label: "Personal Details",
        visited: false,
        active: false,
        children: null
    }
];

export const APPOINTMENT_STEP_MAPPING = ["brand", "model", "date"];

export const DEFAULT_PROGRESS_MAPPING = [
    "brand",
    "model",
    "year",
    "variant",
    "registrationState",
    "kilometersDriven"
];

export const MARKETING_PROGRESS_MAPPING = ["brand", "model", "branch"];

export const progressMapping = {
    default: {
        progress: DEFAULT_PROGRESS_BAR,
        order: DEFAULT_PROGRESS_MAPPING
    },
    oneStep: {
        progress: APPOINTMENT_PROGRESS_BAR,
        order: APPOINTMENT_STEP_MAPPING
    },
    marketing: {
        progress: MARKETING_PROGRESS_BAR,
        order: MARKETING_PROGRESS_MAPPING
    }
};

export const parseDataForProgress = ({ data, comparator }) => {
    const ar = [];
    comparator.forEach(element => {
        let children = {};
        if (element.children) {
            children = { ...element.children };
            Object.keys(element.children).forEach((item) => {
                children[item] = data[item];
            });
            element.children = children;
        }
        ar.push(element);
    });

    let reset = false;
    ar.forEach(element => {
        //reset all element states following
        if (reset) {
            element.visited = false;
            element.active = false;
        } else if (element.children) {
            Object.keys(element.children).forEach((item, index) => {
                // reset current element state if first object of children is false
                if (index === 0 && !element.children[item]) {
                    reset = true;
                    element.visited = false;
                    element.active = false;
                }
            });
        }
    });

    return ar;
};

const generateKeyState = (arr, key) => {
    const data = {};
    let current = true;
    arr.forEach(element => {
        if (element === key) {
            data[element] = current;
            current = false;
        } else {
            data[element] = current;
        }
    });
    return data;
};

export const parseLeadProgress = ({ type, key, progressBarData }) => {
    return parseDataForProgress({
        data: generateKeyState(progressMapping[type].order, key),
        comparator: progressBarData
    });
};
